module.exports = __webpack_public_path__ + "static/media/Prepublication.0b43b193.png";